export function IconGift({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      focusable="false"
      aria-hidden="true"
    >
      {/* Box-Body */}
      <rect x="4" y="11" width="16" height="9" rx="0.5" />
      {/* Box-Deckel (etwas breiter) */}
      <rect x="3" y="8" width="18" height="3" rx="0.5" />
      {/* Vertikales Geschenkband */}
      <path d="M12 8 V20" />
      {/* Schleifen-Ohren oben (zwei Tropfen, die sich in der Mitte treffen) */}
      <path d="M12 8 C12 6 10 4 8 5 C7 6 8 8 12 8 Z" />
      <path d="M12 8 C12 6 14 4 16 5 C17 6 16 8 12 8 Z" />
    </svg>
  );
}
